
// const rules = `<p style="text-align: justify;">Timer starts as soon as you click on '<strong>Start' button</strong>. You have to&nbsp;<strong>complete the test within the specified time</strong>&nbsp;and no extra time is allowed.&nbsp;</p>
// <p style="text-align: justify;">You can&nbsp;<strong>attempt the test one more time after finishing your first attempt</strong>. Once you click on the 'Finish' button, a pop-up box will appear. If you click on 'Submit' button on the box, no changes can be done after it.&nbsp;</p>
// <p style="text-align: justify;">Once you select an option,&nbsp;<strong>&lsquo;Clear&rsquo; button appears. Use this button to erase a chosen option.&nbsp;</strong></p>
// <p style="text-align: justify;">This test consists of&nbsp;<strong>100 questions only in English.</strong>&nbsp;Each item comprises four responses. You have to select only one response. In case you feel that there is more than one correct response, mark the response which you consider the best.&nbsp;</p>
// <p style="text-align: justify;">There is&nbsp;<strong>negative marking for incorrect answers.</strong>&nbsp;The penalty for incorrect answer is one-third of the marks allotted to that question.&nbsp;</p>
// <p style="text-align: justify;">Mark only one option in the answer sheet for each question. If you mark more than one answer, then the question will be deemed incorrect even if one of the answer options you marked happens to be the correct answer.&nbsp;</p>
// <p style="text-align: justify;">If a question is left unanswered, i.e., no option is marked, then no marks will be deducted for that question.</p>`




import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import CivilContent from '../../AllPageContent/AllPageContent'
import { SlArrowLeft } from 'react-icons/sl';

const Instructions = ({ exam }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { ExamType, Marks_per_Question, QuestionsToBeAttempted, Duration, testNumber, TestInstructions, Subject } = location?.state?.testDetails
    console.log(Subject, ExamType);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [accepted, setAccepted] = useState(false);

    const rules = `<p style="text-align: justify;">Timer starts as soon as you click on '<strong>Start' button</strong>. You have to&nbsp;<strong>complete the test within the specified time</strong>&nbsp;and no extra time is allowed.&nbsp;</p>
<p style="text-align: justify;">You can&nbsp;<strong>attempt the test one more time after finishing your first attempt</strong>. Once you click on the 'Finish' button, a pop-up box will appear. If you click on 'Submit' button on the box, no changes can be done after it.&nbsp;</p>
<p style="text-align: justify;">Once you select an option,&nbsp;<strong>&lsquo;Clear&rsquo; button appears. Use this button to erase a chosen option.&nbsp;</strong></p>
<p style="text-align: justify;">This test consists of&nbsp;<strong>100 questions only in English.</strong>&nbsp;Each item comprises four responses. You have to select only one response. In case you feel that there is more than one correct response, mark the response which you consider the best.&nbsp;</p>
<p style="text-align: justify;">There is&nbsp;<strong>negative marking for incorrect answers.</strong>&nbsp;The penalty for incorrect answer is one-third of the marks allotted to that question.&nbsp;</p>
<p style="text-align: justify;">Mark only one option in the answer sheet for each question. If you mark more than one answer, then the question will be deemed incorrect even if one of the answer options you marked happens to be the correct answer.&nbsp;</p>
<p style="text-align: justify;">If a question is left unanswered, i.e., no option is marked, then no marks will be deducted for that question.</p>`;

    return (
        <div className="container-fluid p-sm-4 bg-light" style={{ overflowX: 'hidden' }}>
            <div className="row">
                <div className="col-md-3">
                    <div className='test-background p-2 pt-2 h-100'>
                        <button
                            onClick={() => navigate('/StudentDashboard', { state: { prePath: location.pathname, testDetails: location?.state?.testDetails } })}
                            className='btn btn-sm'
                            style={{
                                backgroundColor: '#17a2b8',
                                color: 'white',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '4px 12px',
                                border: 'none',
                                borderRadius: '4px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                cursor: 'pointer',
                                marginBottom: '10px'
                            }}
                        >
                            <SlArrowLeft /> Back
                        </button>
                        <div className='d-grid gap-3'>
                            <button type="button" className="btn bg-darkblue btn-md py-2" style={{ whiteSpace: 'normal', wordWrap: 'break-word', fontSize: '0.9rem' }}>
                                {<>{Subject ? ((ExamType ? ' : ' : '') + Subject) : ExamType}</>} : {'Test-' + testNumber}
                                <hr className='my-1' />
                                {QuestionsToBeAttempted} Ques | {Duration} min | {Marks_per_Question * QuestionsToBeAttempted} marks
                            </button>
                            <button type="button" className="btn bg-darkorange btn-md py-3">OVERVIEW</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-9">
                    <h2 className="text-center text-danger fs-4 fw-semibold mb-1">Read Instructions Carefully</h2>

                    <div className="p-3 mb-4 rounded bg-warning-subtle shadow-sm border-start border-4 border-warning">
                        <CivilContent paragraphs={TestInstructions || rules} />
                    </div>

                    {/* Checkbox for Terms and Conditions */}
                    <div className="form-check text-center mb-3 d-flex justify-content-center align-items-center">
                        <input
                            type="checkbox"
                            id="acceptTerms"
                            className="form-check-input"
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                            style={{
                                transform: 'scale(1.5)',
                                cursor: 'pointer',
                                marginRight: '8px',
                                border: '1px solid',
                                borderColor: accepted ? 'green' : 'red',
                                borderRadius: '4px', // optional for rounded corners
                            }}
                        />


                        <label className="form-check-label ms-2 mt-1 text-justify" htmlFor="acceptTerms">
                            I have read and understood the instructions. All computer hardware allotted to me are in proper working condition. I declare that I am not in possession of / not wearing / not carrying any prohibited gadget like mobile phone, bluetooth devices etc. /any prohibited material with me into the Examination Hall. I agree that in case of not adhering to the instructions, I shall be liable to be debarred from this Test and/or to disciplinary action, which may include ban from future Tests / Examinations.
                        </label>
                    </div>

                    {/* Start Button */}
                    <div className="text-center">
                        <Link
                            to={'/' + exam + '/online-exam/live-test'}
                            state={{ testDetails: location?.state?.testDetails }}
                            className="btn btn-success px-4 py-2 fw-bold shadow-sm"
                            style={{
                                pointerEvents: accepted ? 'auto' : 'none',
                                cursor: accepted ? 'pointer' : 'not-allowed',
                                opacity: accepted ? 1 : 0.6,
                                backgroundColor: '#28a745',
                                color: 'white',
                                border: 'none',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}
                        >
                            Start Test
                        </Link>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Instructions;
